var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list',{attrs:{"log":true,"tableDatas":_vm.tableDatas,"getTableDatas":_vm.getTableDatas}})}
var staticRenderFns = []

export { render, staticRenderFns }